import Typography from "antd/lib/typography";
import Tag from "antd/lib/tag";

import styles from "./header.module.css";

const { Title } = Typography;

export default function Header({ isTestMode }) {
    return (
        <div className={styles.header}>
        <Title level={4} className={styles.title}>Storm Strategies History</Title>
        <Typography.Text className={styles.subtitle}>
          View and manage all storm strategies sent to sites
          {isTestMode && (
            <Tag color="warning" style={{ marginLeft: '8px' }}>
              Test Mode
            </Tag>
          )}
        </Typography.Text>
      </div>
    )
}